module.exports = __webpack_public_path__ + "static/media/folder_blue.3b741125.png";